"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SwitchButtonsGroup = SwitchButtonsGroup;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Button_1 = require("../Button");
const ButtonsWrap = styled_components_1.default.div `
	display: flex;
	flex-wrap: wrap;

	&& {
		.ant-btn {
			border-radius: 0px;
			margin: 0.25rem 0;
			margin-left: -1px;
		}
		/* .ant-btn:not(:first-child) {
			margin-left: -1px;
		} */
		.ant-btn:first-child {
			border-radius: 4px 0 0 4px;
		}
		.ant-btn:last-child {
			border-radius: 0 4px 4px 0;
		}
	}
`;
function SwitchButtonsGroup(props) {
    const { options, activeButton, defaultActiveButton, setActiveValue, onChange, ...otherProps } = props;
    const active = activeButton || defaultActiveButton;
    return ((0, jsx_runtime_1.jsx)(ButtonsWrap, { className: otherProps.className, children: options.map(option => {
            const buttonType = active === option.value ? 'primary' : 'default';
            return ((0, jsx_runtime_1.jsx)(Button_1.Button, { onClick: () => {
                    setActiveValue === null || setActiveValue === void 0 ? void 0 : setActiveValue(active === option.value ? null : option.value);
                    onChange === null || onChange === void 0 ? void 0 : onChange(active === option.value ? null : option.value);
                }, type: buttonType, ...otherProps, children: option.label }, option.value));
        }) }));
}
